module.exports = __webpack_public_path__ + "img/FonepayPrimary.802bff43.png";